orders-planner-line-ui-schedules
  orders-planner-line-ui-schedules-cell(each="{id in opts.schedules}" tag-scope="{dataScopeSchedule(id)}")
  script(type="typescript").
    this.mixin('orders.planner.line-ui.schedules');
